// extracted by mini-css-extract-plugin
export default {"Center":"NewsLetter_Center__kmITj","TableHead":"NewsLetter_TableHead__LswBI","TableData":"NewsLetter_TableData__O9Tn3"};